import * as T from '@effect-ts/core/Effect'
import type { AxiosError } from 'axios'
import axios from 'axios'

import { Contact } from '../../_models/Contact'
import { Evaluation } from '../../_models/Evaluation'
import { createTripDashboardAxiosChangeInterceptor } from '../../trip-dashboard/utils/tripDashboardInterceptor'
import { GetType } from './axios'

const apiAxios = axios.create({
  baseURL: '/api/',
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
})

// Add response interceptor to emit events when trip dashboard data changes
createTripDashboardAxiosChangeInterceptor(apiAxios)

export default apiAxios

export const GET_Contact = (id: number): T.IO<string | Error | AxiosError, Contact> =>
  GetType(Contact)(`/api/contact/v1/${id}`)

export const GET_Evaluation = (id: number): T.IO<string | Error | AxiosError, Evaluation> =>
  GetType(Evaluation)(`/api/evaluation/v1/${id}`)
